<template>
  <div class="h-full my-auto">
    <p class="text-xl font-bold mb-5">
      Bienvenue dans la démonstration myDid !
    </p>
    <p class="">
      Explorez un univers où la sécurité numérique rencontre l'innovation. myDid
      vous invite à découvrir son processus d'authentification révolutionnaire.
    </p>
    <p class="mb-5">Prêt à plonger dans le monde de l'identité numérique ?</p>
    <p class="mb-3">Choisissez votre chemin :</p>
    <div class="flex items-center gap-5 mb-3">
      <p class="text-xl leading-none">•</p>
      <p>
        <span class="font-bold">Se connecter</span> : Si vous avez déjà un
        compte myDid, connectez-vous pour continuer l'aventure.
      </p>
    </div>
    <div class="flex items-center gap-5 mb-10">
      <p class="text-xl leading-none">•</p>
      <p>
        <span class="font-bold">S'inscrire</span> : Nouveau dans le monde myDid
        ? Créez un compte et commencez votre voyage vers l'innovation numérique.
      </p>
    </div>

    <div class="lg:flex justify-center gap-5">
      <router-link to="/sign?account=0"
        ><p
          class="text-sm text-white text-center bg-secondary font-semibold w-56 md:w-96 rounded-lg py-3 px-5 cursor-pointer"
        >
          S'inscrire
        </p></router-link
      >
    </div>
    <div class="flex w-full pt-5 pb-3 md:justify-center items-center gap-4">
      <div class="w-24 shrink border-b"></div>
      <div class="text-center font-bold">ou</div>
      <div class="w-24 shrink border-b"></div>
    </div>
    <p class="md:text-center">
      Vous avez déjà effectué la démo ?
      <router-link to="/sign?account=1"
        ><span class="font-bold underline text-secondary cursor-pointer"
          >Se connecter</span
        ></router-link
      >
    </p>
  </div>
</template>
